export const covidDisplayAttributes = {
  mandatoryMask: {
    text: 'Masks Required',
    icon: 'mask',
    display: true
  },
  healthCert: {
    text: 'Health Screening and/or Waiver',
    icon: 'checklist',
    display: true,
    helperText: {
      title: 'Health Screening and/or Wavier',
      content: 'The airline requires a health certificate or health documentation/declaration to allow travel. Such documentation may include but is not limited to sign a waiver upon check-in or a full COVID- 19 test.'
    }
  },
  tempChecks: {
    text: 'Temperature Check',
    icon: 'sick',
    display: true
  },
  extraCleaning: {
    text: 'Enhanced Cleaning Protocols',
    icon: 'cleaningProducts',
    display: true
  },
  middleSeatBlocked: {
    text: 'No Middle Seat',
    icon: 'noSeat',
    display: true
  },
  reducedOnboard: {
    text: 'Reduced Amenity Cabin Service',
    icon: 'restaurant',
    display: true,
    helperText: {
      title: 'Reduced Amenity Cabin Service',
      content: 'The airline has reduced or restricted on-board service and facilities, such as food and beverage in order to minimize contact between passengers and crew.'
    }
  },
  hepaFilters: {
    text: 'High Efficiency Air Filters',
    icon: null,
    display: false
  },
  amenityKit: {
    text: 'Sanitizing kit',
    icon: null,
    display: false
  },
  updatedBoarding: {
    text: 'Revised Boarding Procedures',
    icon: null,
    display: false
  },
  cabinBagsRestricted: {
    text: 'Restricted Cabin Space for Baggage',
    icon: null,
    display: false
  },
  dateUntil: {
    text: '',
    icon: null,
    display: false
  }
}
